import script from "./Affix.vue?vue&type=script&setup=true&lang=ts"
export * from "./Affix.vue?vue&type=script&setup=true&lang=ts"

import "./Affix.vue?vue&type=style&index=0&id=3d2a046b&lang=scss&scoped=true"

import exportComponent from "/root/myagent/_work/116/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2a046b"]])

export default __exports__